import * as React from "react";
import { isVariantEnabled, Experiment } from "components/utility/experiment";
import { RedirectBannerProps } from "./typings";

const RedirectBannerWrapper = (props: RedirectBannerProps) => {
  const { context } = props;

  const [redirectBanner, setRedirectBanner] = React.useState<React.ReactElement | null>(null);

  React.useEffect(() => {
    if (!isVariantEnabled(context, Experiment.Flex_HTG_Blossom_POSa_Redirect_Banner)) {
      return;
    }

    const getRedirectBanner = async () => {
      const {
        RedirectBanner
      } = await import(/* webpackChunkName: "RedirectBanner" */ "redirect-banner-react");

      setRedirectBanner(<RedirectBanner siteid={context.site.id} langid={context.langId} />);
    };

    getRedirectBanner();
  }, []);

  return redirectBanner;
};

export default RedirectBannerWrapper;
